'use strict';

/**
 * WARNING: this file is generated by toolkit.
 * You should import and use it in other files,
 * DO NOT modify it!!!!
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultProps = exports.propTypes = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var string = _propTypes2.default.string,
    number = _propTypes2.default.number,
    bool = _propTypes2.default.bool,
    arrayOf = _propTypes2.default.arrayOf,
    object = _propTypes2.default.object,
    objectOf = _propTypes2.default.objectOf,
    any = _propTypes2.default.any,
    oneOfType = _propTypes2.default.oneOfType,
    func = _propTypes2.default.func;
var propTypes = exports.propTypes = {
  /**
   * className
   */
  className: string,
  /**
   * dataSource
   */
  dataSource: arrayOf(object),
  /**
   * value
   */
  value: oneOfType([arrayOf(object), objectOf(any)]),
  notFoundContent: string,
  /**
   * whether support multiple select
   */
  multiple: bool,
  /**
   * whether show search ipt
   */
  showSearch: bool,
  /**
   * support lazyload
   */
  lazyLoad: bool,
  /**
   * loading status
   */
  loading: bool,
  /**
   * search data by local data or fireEvent
   */
  searchLocal: bool,
  /**
   * threshold when scroll to bottom
   */
  threshold: number,
  /**
   * invoke when search by remote server(searchLocal set false)
   */
  onSearchChange: func,
  /**
   * select set lazyLoad && offsetBottom < threshold will trigger this cb
   */
  onLoadMore: func,
  /**
   * data change
   */
  onChange: func
};

var defaultProps = exports.defaultProps = {
  className: '',
  dataSource: [],
  value: [],
  multiple: false,
  showSearch: false,
  lazyLoad: false,
  loading: false,
  visible: false,
  threshold: 0,
  notFoundContent: '无选项',
  searchLocal: true,
  onSearchChange: function onSearchChange() {},
  onLoadMore: function onLoadMore() {},
  onChange: function onChange() {}
};